module.exports = __webpack_public_path__ + "static/img/088_TO8_1743.e4aeb99.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/088_TO8_1743.jpg
// module id = cURA
// module chunks = 0